import React, { useCallback, useEffect, useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import Table from "../../../components/elements/table/Table";
import { status_filter } from "../../../constant/Constant";
import Select from "../../../components/form/Select";
import Input from "../../../components/form/Input";
import Button from "../../../components/form/Button";
import { setTitle } from "../../../helpers/MetaTag";
import DeleteModal from "../../../components/common/DeleteModal";
import { changeFaqStatus, deleteFaq, getFaqList } from "../../../services/faqService";
import { useDebounce } from "../../../hooks/useDebounce";
import Modal from "../../../components/elements/Modal/Modal";
import { FaqDetailsModal } from "./FaqDetailsModal";

const FaqList = () => {
  const location = useLocation();
  // setTitle("HJL");
  const navigate = useNavigate();
  const [limit, setLimit] = useState(10);
  const [status, setStatus] = useState("all");
  const [featured, setFeatured] = useState(" ");
  const [offset, setOffset] = useState(0);
  const [sort, setSort] = useState({ orderBy: "", ordering: "DESC" });
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [pagination, setPagination] = useState({
    hasNextPage: false,
    hasPrevPage: false,
  });
  const [statusFilterData, setStatusFilterData] = useState(status_filter || []);
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 200);
  const [list, setList] = useState({
    loading: true,
    data: [],
    pageCount: 0,
    totalItem: 0,
  });
  const [count, setCount] = useState(0);
  const [selectedItems, setSelectedItems] = useState([]);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    id: null,
  });
  const [deleteComplete, setDeleteComplete] = useState(false);
  const [filterSearchKey, setFilterSearchKey] = useState("");
  const [filters, setFilters] = useState({
    status: null,
  });
  const [isOpen, setIsOpen] = useState(false);
  const [details, setDetails] = useState({});

  const data = [
    { name: "All Items", value: "All" },
    { name: "5 Items", value: 5 },
    { name: "10 Items", value: 10 },
    { name: "20 Items", value: 20 },
    { name: "30 Items", value: 30 },
    { name: "50 Items", value: 50 },
    { name: "100 Items", value: 100 },
  ];

  //Page data limit function
  const handleChange = (value) => {
    if (value?.value !== "All") {
      setOffset(0);
      setLimit(value?.value);
      setSelectedItems([]);
    } else {
      setOffset(0);
      setLimit(count);
      setCurrentPage(1);
      setSelectedItems([]);
    }
  };

  useEffect(() => {
    if (filterSearchKey) {
      setStatusFilterData(
        status_filter?.filter((item) => item?.name?.toLocaleLowerCase().includes(filterSearchKey?.toLocaleLowerCase()))
      );
    } else {
      setStatusFilterData(status_filter);
    }
  }, [filterSearchKey]);

  const handleFilterChange = useCallback((name, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  }, []);

  //   loading the member list >>>>>>>>>
  const loadList = useCallback(() => {
    const status_filter = {};
    if (filters.status && Array.isArray(filters.status) && filters.status.length > 0) {
      filters.status.forEach((item, i) => (status_filter[`status[${i}]`] = item));
    }
    setList((pre) => ({
      ...pre,
      data: [],
      loading: true,
    }));
    getFaqList({
      ...sort,
      keyword: search,
      perPage: limit,
      page: currentPage,
      ...status_filter,
    }).then((res) => {
      if (res && res?.docs?.success) {
        setList({
          loading: false,
          data: res.docs?.data,
          pageCount: res?.docs?.metadata?.totalPages,
          keyword: search,
          totalItem: res?.docs?.metadata?.totalDocs,
        });
        setCount(res?.docs?.metadata?.totalDocs);
        setPagination({
          hasNextPage: res?.docs?.metadata?.hasNextPage,
          hasPrevPage: res?.docs?.metadata?.hasPrevPage,
        });
      } else {
        setList((pre) => ({ ...pre, data: [], loading: false }));
        toast.error(res?.message);
      }
    });
  }, [limit, sort, currentPage, search, filters]);

  useEffect(() => {
    loadList();
  }, [loadList]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageParam = params.get("page");
    if (pageParam) {
      setCurrentPage(parseInt(pageParam, 10));
    }
  }, [location.search]);

  // Pagination Logic
  useEffect(() => {
    if (list?.data?.length <= 0 && pagination?.hasNextPage) {
      setCurrentPage(currentPage);
    } else if (list?.data?.length <= 0 && !pagination?.hasPrevPage) {
      setCurrentPage(1);
    } else if (list?.data?.length <= 0) {
      setCurrentPage(currentPage - 1);
    }
  }, [list?.data.length]);

  //Refresh Function

  const refreshData = () => {
    setLimit(10);
    setKeyword("");
    setSelectedItems([]);
  };

  const viewData = (item) => {
    setIsOpen(true);
    setDetails(item);
  };

  //Table Heading Data >>>>>>>>>

  const tableHeadData = [
    {
      _id: 1,
      name: "Question",
      align: "left",
      isSort: true,
      isFilter: false,
      isFilterSearch: false,
      onSort: (val) => {
        if (val === "DESC") {
          setSort({ orderBy: "question", ordering: "DESC" });
        } else {
          setSort({ orderBy: "question", ordering: "ASC" });
        }
      },
    },
    {
      _id: 2,
      name: "Answer",
      align: "left",
      isSort: true,
      isFilter: false,
      isFilterSearch: false,
      onSort: (val) => {
        if (val === "DESC") {
          setSort({ orderBy: "answer", ordering: "DESC" });
        } else {
          setSort({ orderBy: "answer", ordering: "ASC" });
        }
      },
    },
    {
      _id: 3,
      name: "Status",
      align: "left",
      isFilter: true,
      isFilterSearch: false,
      isSort: false,
      filterData: statusFilterData,
      onFilter: (data) =>
        handleFilterChange(
          "status",
          data?.map((item) => item?.value)
        ),
      filterSearch: (e) => setFilterSearchKey(e),
    },
    {
      _id: 4,
      name: "Created At",
      align: "right",
      isFilter: false,
      isSort: false,
    },
    {
      _id: 5,
      name: "Action",
      align: "right",
      isFilter: false,
      isSort: false,
    },
  ];

  //   Status Change Api Call >>>>>>>>>>

  const handleStatusChange = async (data) => {
    changeFaqStatus({
      id: data.id,
      status: data.status === 1 ? 2 : 1,
    }).then((res) => {
      if (res?.status === 200) {
        setList((pre) => ({
          ...pre,
          data: pre.data.map((item) =>
            item.id === data.id
              ? {
                  ...item,
                  status: item.status === 1 ? 2 : 1,
                }
              : item
          ),
        }));
        toast.success("Status Change Successful");
      } else {
        toast.error("Somthing Went Wrong");
      }
    });
  };

  // Multi selected Rows statuschange
  //   const handleActiveStatusToggle = () => {
  //     changeUserStatus({ ids: selectedItems, status: "active" })
  //       .then((res) => {
  //         if (res.data.status === 200) {
  //           setList((prevState) => ({
  //             ...prevState,
  //             data: prevState.data.map((user) =>
  //               selectedItems.includes(user._id) ? { ...user, status: "active" } : user
  //             ),
  //           }));
  //           setSelectedItems([]);
  //           toast.success(res?.data?.message);
  //         } else {
  //           toast.error(res?.data?.message);
  //         }
  //       })
  //       .catch();
  //   };

  //   const handleInactiveStatusToggle = () => {
  //     changeUserStatus({ ids: selectedItems, status: "inActive" })
  //       .then((res) => {
  //         if (res.data.status === 200) {
  //           setList((prevState) => ({
  //             ...prevState,
  //             data: prevState.data.map((user) =>
  //               selectedItems.includes(user._id) ? { ...user, status: "inActive" } : user
  //             ),
  //           }));
  //           setSelectedItems([]);
  //           toast.success(res?.data?.message);
  //         } else {
  //           toast.error(res?.data?.message);
  //         }
  //       })
  //       .catch();
  //   };

  const addNew = () => {
    navigate("/admin/faq-add");
  };
  const editData = (item) => {
    navigate(`/admin/faq-edit/${item}${location.search}`);
  };

  // Table Body Data >>>>>>>>>
  const tableData = list?.data?.map((item, index) => ({
    _id: item?.id,
    rowData: [
      {
        _id: 1,
        type: "text",
        align: "left",
        cellClass: "!min-w-[100px]",
        data: (
          <div
            dangerouslySetInnerHTML={{
              __html: item?.question.substring(0, 25) + "...",
            }}
          />
        ),
      },
      {
        _id: 2,
        type: "text",
        align: "left",
        cellClass: "!min-w-[100px]",
        data: (
          <div
            dangerouslySetInnerHTML={{
              __html: item?.answer.substring(0, 25) + "...",
            }}
          />
        ),
      },
      {
        _id: 3,
        type: "status",
        align: "left",
        cellClass: "!min-w-[100px]",
        statusLabel: item?.status === 1 ? "Active" : "In Active",
        statusType: item?.status === 1 ? "info" : "danger",
        functions: () => handleStatusChange(item),
      },
      {
        _id: 4,
        type: "text",
        align: "right",
        cellClass: "!min-w-[100px]",
        data: item?.created_at ? moment(item?.created_at).format("MM-DD-YYYY") : "N/A",
      },
      {
        _id: 5,
        type: "action",
        align: "left",
        cellClass: "w-[5%]",
        actionData: [
          {
            _id: 1,
            name: "Edit",
            icon: "fa-regular fa-pen-to-square",
            standout: false,
            onClick: () => editData(item?.id),
          },
          {
            _id: 2,
            name: "View Details",
            icon: "fa-regular fa-eye",
            standout: false,
            onClick: () => viewData(item),
          },
          {
            _id: 3,
            name: "Delete",
            icon: "fa-regular fa-trash-can",
            standout: true,
            onClick: () => {
              setDeleteModal({
                isOpen: true,
                id: item?.id,
              });
            },
          },
        ],
      },
    ],
  }));

  // data delte api call
  // const onDelete = (item) => {
  //   setDeleteComplete(true);
  //   if (deleteModal?.id) {
  //     try {
  //       deleteFaq({ id: deleteModal?.id }).then((res) => {
  //         if (res?.status === 200) {
  //           toast?.success(res?.message);
  //           setList((prevList) => ({
  //             ...prevList,
  //             data: prevList.data.filter((item) => item.id !== deleteModal.id),
  //           }));
  //           setDeleteModal({
  //             isOpen: false,
  //             id: null,
  //           });
  //         } else {
  //           toast.error(res?.message || res?.error);
  //         }
  //       });
  //       setDeleteComplete(false);
  //     } catch (error) {
  //       setDeleteComplete(false);
  //       // toast.error(error);
  //     }
  //   }
  // };

  const onDelete = async () => {
    if (!deleteModal?.id) {
      toast.error("No faq ID specified for deletion");
      return;
    }

    setDeleteComplete(true);

    try {
      const res = await deleteFaq({ id: deleteModal.id });

      if (res?.status === 200) {
        toast.success(res?.message || "Faq deleted successfully");
        setList((prevList) => ({
          ...prevList,
          data: prevList.data.filter((item) => item.id !== deleteModal.id),
          totalItem: prevList.totalItem - 1,
        }));
        setDeleteModal({ isOpen: false, id: null });

        if (list.totalItem % limit === 0 && currentPage > 1) {
          setCurrentPage((prevPage) => prevPage - 1);
        }

        loadList();
      } else {
        toast.error(res?.message || "Failed to delete faq");
      }
    } catch (error) {
      toast.error(error?.message || "An error occurred while deleting the faq");
    } finally {
      setDeleteComplete(false);
    }
  };

  return (
    <>
      <div className="w-full py-4 md:px-6 px-0">
        <div className="font-bold text-3xl m-1 text-secondary mb-5 border-b border-gray-300 pb-2">Faqs</div>
        <div className="mb-6 md:flex block gap-3 md:space-y-0 space-y-2">
          <div className="md:w-40 w-full">
            <Select
              dropdownData={data}
              placeholder={"Select Limit"}
              dropdownButtonClass={"!h-10 !rounded-md "}
              selectedValue={limit}
              onChange={handleChange}
            />
          </div>
          <div className="md:w-80 w-full">
            <Input
              inputType={"text"}
              isInputGroup={true}
              inputGroupPosition={"left"}
              inputGroupIcon={"fa-regular fa-search"}
              inputPlaceholder={"Search"}
              inputClasses={"!pl-3"}
              value={keyword}
              onChange={(e) => {
                setKeyword(e.target.value);
                setCurrentPage(1);
                setSelectedItems([]);
              }}
            />
          </div>
          {/* {selectedItems.length > 0 && (
            <>
              <div className="relative">
                <Button
                  buttonHasLink={false}
                  buttonIcon={"fa-regular fa-badge-check"}
                  buttonIconPosition={"left"}
                  buttonClasses={"!bg-org-green !border-org-border !text-white"}
                  buttonLabel={"Active"}
                  buttonLabelClasses={"font-medium !text-sm"}
                  buttonFunction={handleActiveStatusToggle}
                />
              </div>
            </>
          )}
          {selectedItems.length > 0 && (
            <>
              <div className="relative">
                <Button
                  buttonHasLink={false}
                  buttonIcon={"fa-regular fa-circle-xmark"}
                  buttonIconPosition={"left"}
                  buttonClasses={"!bg-org-red !border-org-border !text-white"}
                  buttonLabel={"In Active"}
                  buttonLabelClasses={"font-medium !text-sm"}
                  buttonFunction={handleInactiveStatusToggle}
                />
              </div>
            </>
          )} */}

          <div className="ml-auto flex justify-end space-x-2">
            <div className="relative group">
              <Button
                buttonHasLink={false}
                buttonIcon={"fa-solid fa-arrows-rotate"}
                buttonIconPosition={"left"}
                buttonClasses={
                  "!bg-secondary !h-10 !text-white !text-bold hover:!bg-secondary !border-org-theme  hover:!text-white"
                }
                buttonLabel={""}
                buttonLabelClasses={"font-medium !text-md xl:block hidden"}
                buttonFunction={refreshData}
              />
              <div className="absolute left-1/2 transform -translate-x-1/2 bottom-full mb-2 hidden group-hover:block px-3 py-2 text-sm text-white bg-gray-800 rounded shadow-lg text-center">
                Reset
              </div>
            </div>
            <div className="relative group">
              <Button
                buttonHasLink={false}
                buttonIcon={"fa-regular fa-plus"}
                buttonIconPosition={"left"}
                buttonClasses={
                  "!bg-secondary !h-10 !text-white !text-bold hover:!bg-secondary !border-org-theme  hover:!text-white"
                }
                buttonLabel={""}
                buttonLabelClasses={"font-medium !text-sm xl:block hidden"}
                buttonFunction={addNew}
              />
              <div className="absolute left-1/2 transform -translate-x-1/2 bottom-full mb-2 hidden group-hover:block px-3 py-2 text-sm text-white bg-gray-800 rounded shadow-lg text-center">
                Add
              </div>
            </div>
          </div>
        </div>
        <div className=" overflow-auto">
          <Table
            tableHeadData={tableHeadData}
            tableData={tableData}
            // containerClasses={"px-6"}
            isLoder={list?.loading}
            pageCount={list?.pageCount}
            currentPage={currentPage}
            onPageChange={(val) => {
              setOffset(limit * val?.selected);
              setCurrentPage(val?.selected);
              setSelectedItems([]);
              navigate(`?page=${val?.selected}`);
            }}
            isOrderingDisabled={true}
            originalData={[...list.data]}
            // handleOrdering={handleOrdering}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            isCheckbox={false}
            setOriginalData={(data) => setList((cur) => ({ ...cur, data }))}
            tableImage={false}
          />
        </div>
      </div>
      <DeleteModal
        open={deleteModal?.isOpen}
        close={() => setDeleteModal({ isOpen: false })}
        loading={deleteComplete}
        deleteHandler={onDelete}
      />
      <Modal open={isOpen} size="xl3">
        <FaqDetailsModal
          onClose={() => setIsOpen(false)}
          details={details}
          setDetails={setDetails}
          loadList={loadList}
        />
      </Modal>
    </>
  );
};

export default FaqList;
